import { Box } from '@betterment/samba-react';
import { css } from '@betterment/samba-styled-system/css';
import { type SystemStyleObject } from '@betterment/samba-styled-system/types';

interface Props {
  css?: SystemStyleObject;
  children: React.ReactNode;
}

export function Logo(props: Props) {
  const { children, css: cssProp, ...restProps } = props;
  const logoCss = css({
    py: 'space.300',
    display: 'flex',
    minHeight: 'size.300',
    alignItems: 'center',
    maxWidth: '200px',
    ...cssProp,
  });
  return (
    <Box className={logoCss} {...restProps}>
      {children}
    </Box>
  );
}

Logo.displayName = 'Nav.Logo';
